var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawbase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.15789C0 1.41384 1.41384 0 3.15789 0H16.8421C18.5862 0 20 1.41384 20 3.15789V16.8421C20 18.5862 18.5862 20 16.8421 20H3.15789C1.41384 20 0 18.5862 0 16.8421V3.15789Z",
    fill: "url(#paint0_linear_3084_25384)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12379 14V6.82297H5.6412V12.7489H8.71807V14H4.12379ZM9.72296 14V6.82297H12.5966C13.1246 6.82297 13.565 6.90123 13.9177 7.05776C14.2705 7.21429 14.5357 7.43156 14.7132 7.70958C14.8908 7.98526 14.9796 8.303 14.9796 8.66278C14.9796 8.94313 14.9235 9.18961 14.8114 9.40221C14.6992 9.61248 14.545 9.78536 14.3488 9.92087C14.1549 10.054 13.9329 10.1487 13.6829 10.2047V10.2748C13.9563 10.2865 14.2121 10.3636 14.4504 10.5061C14.691 10.6486 14.8861 10.8484 15.0356 11.1054C15.1852 11.36 15.2599 11.6637 15.2599 12.0165C15.2599 12.3973 15.1653 12.7372 14.9761 13.0363C14.7892 13.333 14.5123 13.5678 14.1455 13.7407C13.7787 13.9136 13.3267 14 12.7893 14H9.72296ZM11.2404 12.7594H12.4774C12.9003 12.7594 13.2087 12.6788 13.4026 12.5176C13.5965 12.3541 13.6935 12.1368 13.6935 11.8658C13.6935 11.6672 13.6456 11.492 13.5498 11.3402C13.454 11.1883 13.3173 11.0691 13.1398 10.9827C12.9645 10.8963 12.7554 10.853 12.5125 10.853H11.2404V12.7594ZM11.2404 9.82625H12.3653C12.5732 9.82625 12.7578 9.79003 12.919 9.71761C13.0825 9.64285 13.211 9.53772 13.3045 9.40221C13.4003 9.26671 13.4481 9.10434 13.4481 8.9151C13.4481 8.65577 13.3559 8.44668 13.1713 8.28781C12.9891 8.12894 12.7297 8.04951 12.3933 8.04951H11.2404V9.82625Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3084_25384",
    x1: 0,
    y1: 0,
    x2: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4778F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3052A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawbase);
export default __webpack_public_path__ + "static/media/lawbase.479843a85be6f9ad2f1cc46c4e8648f2.svg";
export { ForwardRef as ReactComponent };